/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import React from "react"
import { Flex, SectionGrid } from "frontend/src/components/Layout"
import { BlockText } from "frontend/src/components/BlockText"
import Img from "gatsby-image"
import { getFluidFromAsset } from "frontend/src/utils/gatsbyImageHelpers"

function HeroDesktop({
  text,
  background = {},
  decorative = {},
  height = undefined,
  alignment = "center",
}) {
  const { decorativeLeft, decorativeRight } = decorative
  const { backgroundColor, imageDesktop } = background
  const styles = backgroundColor ? { backgroundColor: backgroundColor } : {}
  const heightVal = height === "small" ? "350px" : "600px"
  const justify = alignment === "left" ? "flex-start" : "center"
  const column = alignment === "left" ? "2 / span 3" : "3 / span 1"
  const px = alignment === "left" ? 0 : 8
  return (
    <div
      sx={{
        ...styles,
        height: heightVal,
        position: "relative",
        display: ["none", "none", "grid"],
        gridTemplateColumns: "1fr minmax(25px,200px) minmax(700px,900px) minmax(25px,200px) 1fr",
        gridTemplateRows: heightVal,
      }}
    >
      {imageDesktop && (
        <Img
          fluid={getFluidFromAsset(imageDesktop, 2000)}
          sx={{ gridColumn: "1 / span 5", gridRow: "1 / span 1", width: "100%" }}
        />
      )}
      <Flex.row
        align="center"
        justify={justify}
        sx={{
          gridColumn: column,
          gridRow: "1 / span 1",
          width: "95%",
          my: [7, 12],
        }}
      >
        <div
          sx={{
            px: px,
            textAlign: alignment,
            maxWidth: alignment === "left" ? "950px" : "100%",
          }}
        >
          <BlockText
            blocks={text}
            style={{ fontSize: "52px", lineHeight: "60px", letterSpacing: "-2px" }}
          />
        </div>
      </Flex.row>
      {decorativeLeft && (
        <Img
          fluid={getFluidFromAsset(decorativeLeft, 200)}
          sx={{
            gridRow: "1 / span 1",
            gridColumn: "1 / span 2",
            zIndex: "2",
            width: "200px",
            height: "200px",
            top: "75px",
            alignSelf: "end",
            justifySelf: "center",
            display: ["none", "none", "block"],
          }}
          imgStyle={{ objectFit: "contain" }}
        />
      )}
      {decorativeRight && (
        <Img
          fluid={getFluidFromAsset(decorativeRight, 200)}
          sx={{
            gridRow: "1 / span 1",
            gridColumn: "4 / span 2",
            zIndex: "2",
            width: "200px",
            height: "200px",
            top: "75px",
            alignSelf: "end",
            justifySelf: "center",
            display: ["none", "none", "block"],
          }}
          imgStyle={{ objectFit: "contain" }}
        />
      )}
    </div>
  )
}

function HeroMobile({ text, background, height, alignment }) {
  const { backgroundColor, imageMobile } = background
  const styles = backgroundColor ? { backgroundColor: backgroundColor } : {}
  const heightVal = height === "small" ? ["145px", "230px"] : "470px"
  const margins = alignment === "left" ? { ml: "16px" } : { mx: "auto" }
  return (
    <div
      sx={{
        ...styles,
        height: heightVal,
        position: "relative",
        display: ["grid", "grid", "none"],
        gridTemplateColumns: "1fr",
        gridTemplateRows: "1fr",
      }}
    >
      {imageMobile && (
        <Img
          fluid={getFluidFromAsset(imageMobile, 1000)}
          sx={{ gridColumn: "1 / span 1", gridRow: "1 / span 1", width: "100%" }}
        />
      )}
      <Flex
        justify="center"
        align={alignment === "center" ? "center" : "flex-start"}
        sx={{
          gridColumn: "1 / span 1",
          gridRow: "1 / span 1",
          width: "100%",
          my: [7, 12],
        }}
      >
        <div sx={{ textAlign: alignment, width: "90%", ...margins }}>
          <BlockText
            blocks={text}
            lang="de"
            style={{
              fontSize: ["26px", "42px"],
              lineHeight: ["32px", "46px"],
              letterSpacing: ["-1px", "-2px"],
              hyphens: "auto",
              MozHyphens: "auto",
              msHyphens: "auto",
              WebkitHyphens: "auto",
            }}
          />
        </div>
      </Flex>
    </div>
  )
}

function HeroElement({ text, textMobile, background, width, decorative, height, alignment }) {
  return (
    <React.Fragment>
      <HeroDesktop
        text={text}
        background={background}
        decorative={decorative}
        height={height}
        alignment={alignment}
      />
      <HeroMobile text={textMobile} background={background} height={height} alignment={alignment} />
    </React.Fragment>
  )
}

function HeroTextOnBackground({
  text,
  textMobile,
  background,
  width,
  decorative,
  height,
  alignment,
}) {
  const mobile = textMobile ? textMobile : text
  if (width === "full") {
    return (
      <div sx={{ width: "100%" }}>
        <HeroElement
          text={text}
          textMobile={mobile}
          alignment={alignment}
          background={background}
          width={width}
          decorative={decorative}
          height={height}
        />
      </div>
    )
  }
  const Element = width === "wide" ? SectionGrid.wide : SectionGrid.narrow
  return (
    <SectionGrid>
      <Element>
        <HeroElement
          text={text}
          textMobile={mobile}
          background={background}
          alignment={alignment}
          width={width}
          decorative={decorative}
          height={height}
        />
      </Element>
    </SectionGrid>
  )
}

export { HeroTextOnBackground }
